(function () {
  const ARTICLE_SELECTOR = '.mag-article__content:not(.mag-article__content--gated), .mag-article__content-partial';
  const IMAGE_SELECTOR = 'img';
  const DEFAULT_COLUMN_WIDTH = 720;
  const pendingImages = new WeakSet();

  const parsePixelValue = (value) => {
    if (!value) return 0;
    const match = String(value).trim().match(/^(\d+(?:\.\d+)?)px?$/i);
    return match ? Number.parseFloat(match[1]) : 0;
  };

  const getColumnReferenceWidth = (container) => {
    const article = container.closest('.mag-article');
    const rawMax = article
      ? getComputedStyle(article).getPropertyValue('--mag-art-content-max')
      : '';
    return parsePixelValue(rawMax) || DEFAULT_COLUMN_WIDTH;
  };

  const getEditorWidth = (image) => {
    const widthAttr = Number.parseFloat(image.getAttribute('width') || '');
    if (Number.isFinite(widthAttr) && widthAttr > 0) return widthAttr;

    const inlineWidth = parsePixelValue(image.style.width);
    if (inlineWidth > 0) return inlineWidth;

    if (image.naturalWidth > 0) return image.naturalWidth;

    return 0;
  };

  const getNumericAttribute = (image, name) => {
    const value = (image.getAttribute(name) || '').trim();
    return /^\d+(\.\d+)?$/.test(value) ? Number.parseFloat(value) : 0;
  };

  const isPortrait = (image) => {
    const width = getNumericAttribute(image, 'width');
    const height = getNumericAttribute(image, 'height');
    if (width > 0 && height > 0) return height > width;
    return image.naturalWidth > 0 && image.naturalHeight > image.naturalWidth;
  };

  const getAlignment = (element) => {
    const alignAttr = (element.getAttribute('align') || '').toLowerCase();
    const inlineTextAlign = (element.style.textAlign || '').toLowerCase();
    const inlineMarginLeft = element.style.marginLeft;
    const inlineMarginRight = element.style.marginRight;
    const className = element.className || '';

    if (
      alignAttr === 'center' ||
      inlineTextAlign === 'center' ||
      (inlineMarginLeft === 'auto' && inlineMarginRight === 'auto') ||
      /\b(center|aligncenter)\b/i.test(className)
    ) {
      return 'center';
    }

    if (
      alignAttr === 'right' ||
      inlineTextAlign === 'right' ||
      inlineMarginLeft === 'auto' ||
      /\b(right|alignright)\b/i.test(className)
    ) {
      return 'flex-end';
    }

    return 'flex-start';
  };

  const applySizing = (image, container) => {
    const editorWidth = getEditorWidth(image);
    if (!editorWidth) return;

    const referenceWidth = getColumnReferenceWidth(container);
    const columnShare = Math.min((editorWidth / referenceWidth) * 100, 100);
    const figure = image.closest('figure');
    const sizingTarget = figure && container.contains(figure) ? figure : image;
    const alignTarget = figure || image;

    image.dataset.magArticleBodyImage = 'true';
    sizingTarget.dataset.magArticleBodyImageBox = 'true';
    sizingTarget.style.setProperty('--mag-rte-image-editor-width', `${editorWidth}px`);
    sizingTarget.style.setProperty('--mag-rte-image-column-share', `${columnShare}%`);
    sizingTarget.style.setProperty('--mag-rte-image-align', getAlignment(alignTarget));

    if (isPortrait(image)) {
      sizingTarget.dataset.magArticleBodyImagePortrait = 'true';
    } else {
      delete sizingTarget.dataset.magArticleBodyImagePortrait;
    }
  };

  const initImage = (image, container) => {
    const hasWidth = getNumericAttribute(image, 'width') > 0;
    if (image.complete || hasWidth) applySizing(image, container);

    // Images without both dimensions are sized again once their natural size is known.
    if (image.complete || pendingImages.has(image)) return;
    if (hasWidth && getNumericAttribute(image, 'height') > 0) return;

    pendingImages.add(image);
    image.addEventListener(
      'load',
      () => {
        pendingImages.delete(image);
        applySizing(image, container);
      },
      { once: true }
    );
  };

  const initArticleImages = () => {
    document.querySelectorAll(ARTICLE_SELECTOR).forEach((container) => {
      container.querySelectorAll(IMAGE_SELECTOR).forEach((image) => initImage(image, container));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleImages);
  } else {
    initArticleImages();
  }

  document.addEventListener('shopify:section:load', initArticleImages);
})();
